import fixedCostService from "../api/server/fixedCostService";
import errorHelper from "@/components/helpers/errorhelper";
import authentication from "@/authentication";
export const FIXED_COST_NAMESPACE = "fixedCostModule";

var fakeService;
const loadFakeService = async () => {
  if (fakeService) return fakeService;
  return import(
    `../api/${process.env.VUE_APP_SERVICE_FOLDER}/fixedCostService`
  ).then(x => {
    fakeService = x.default;
    return fakeService;
  });
};

var services = {
  api:
    (process.env.VUE_APP_SERVICE_FOLDER === "fakes" &&
      process.env.NODE_ENV === "development") ||
    process.env.NODE_ENV === "test"
      ? loadFakeService()
      : Promise.resolve(fixedCostService)
};

const state = {
  courierCOG: [],
  fixedCosts: [],
  budgets: [],
  loading: true
};

const actions = {
  async deleteCourierCOG(context, monthYear) {
    var api = await services.api;
    return api
      .deleteCourierCOG(monthYear)
      .then(function(value) {
        var found = -1;
        for (var i = 0; i < state.courierCOG.length; i++) {
          if (
            state.courierCOG[i].MonthYear.substring(0, 7) ===
            monthYear.substring(0, 7)
          )
            found = i;
        }
        state.courierCOG.splice(found, 1);
      })
      .catch(function(err) {
        errorHelper.showError(err);
      });
  },
  async deleteFixedCostItem(context, id) {
    var api = await services.api;
    return api
      .deleteFixedCostItem(id)
      .then(function(value) {
        var found = -1;
        for (var i = 0; i < state.fixedCosts.length; i++) {
          if (state.fixedCosts[i].Id === id) found = i;
        }
        state.fixedCosts.splice(found, 1);
      })
      .catch(function(err) {
        errorHelper.showError(err);
      });
  },
  async deleteBudgetItem(context, id) {
    var api = await services.api;
    return api
      .deleteBudgetItem(id)
      .then(function(value) {
        var found = -1;
        for (var i = 0; i < state.budgets.length; i++) {
          if (state.budgets[i].Id === id) found = i;
        }
        state.budgets.splice(found, 1);
      })
      .catch(function(err) {
        errorHelper.showError(err);
      });
  },
  async loadCourierCOG(context) {
    var api = await services.api;
    return api
      .loadCourierCOG(context)
      .then(function(value) {
        context.commit("SET_COURIER_COG", value);
        context.state.loading = false;
      })
      .catch(function(err) {
        errorHelper.showError(err);
      });
  },
  async loadFixedCostItems(context) {
    var api = await services.api;
    return api
      .loadFixedCostItems(context)
      .then(function(value) {
        context.commit("SET_FIXED_COST", value);
        context.state.loading = false;
      })
      .catch(function(err) {
        errorHelper.showError(err);
      });
  },
  async loadBudgetItems(context) {
    var api = await services.api;
    return api
      .loadBudgetItems(context)
      .then(function(value) {
        context.commit("SET_BUDGET", value);
        context.state.loading = false;
      })
      .catch(function(err) {
        errorHelper.showError(err);
      });
  },
  async saveCourierCOG(context, data) {
    var api = await services.api;
    return api
      .saveCourierCOG({
        MonthYear: data.MonthYear,
        EstimatedCostPercentage: data.EstimatedCostPercentage,
        CourierAdjustmentPercentage: data.CourierAdjustmentPercentage,
        ShippingDays: data.ShippingDays
      })
      .then(function(value) {
        var savedItem = context.state.courierCOG.find(
          x => x.MonthYear.substring(0, 7) === data.MonthYear.substring(0, 7)
        );
        if (!savedItem) context.state.courierCOG.push(data);
        else {
          savedItem.EstimatedCostPercentage = data.EstimatedCostPercentage;
          savedItem.CourierAdjustmentPercentage =
            data.CourierAdjustmentPercentage;
          savedItem.ShippingDays =
            data.ShippingDays;
        }
      })
      .catch(function(err) {
        errorHelper.showError(err);
      });
  },
  async saveFixedCostItems(context, data) {
    var api = await services.api;
    return api
      .saveFixedCostItems({
        Id: data.Id,
        Cost: data.Cost,
        Shrinkage: data.Shrinkage,
        AvgLaborCostPerHour: data.AvgLaborCostPerHour,
        WeekEnding: data.WeekEnding,
        ActiveDirectoryId: authentication.getUser().profile.oid,
        BoxRevenue: data.BoxRevenue,
        BoxCost: data.BoxCost,
        TechnologyCost: data.TechnologyCost,
        ImplementationFee: data.ImplementationFee
      })
      .then(function(value) {
        if (data.Id === 0) {
          data.Id = value.Id;
          context.state.fixedCosts.push(data);
        }
      })
      .catch(function(err) {
        errorHelper.showError(err);
      });
  },
  async saveBudgetItems(context, data) {
    var api = await services.api;
    return api
      .saveBudgetItems({
        Id: data.Id,
        WeekEnding: data.WeekEnding,
        ShippingDays: data.ShippingDays,
        TrackerBudget: data.TrackerBudget,
        TrackerThreePlusNine: data.TrackerThreePlusNine,
        TrackerSixPlusSix: data.TrackerSixPlusSix,
        TrackerNinePlusThree: data.TrackerNinePlusThree,
        ProtectorBudget: data.ProtectorBudget,
        ProtectorThreePlusNine: data.ProtectorThreePlusNine,
        ProtectorSixPlusSix: data.ProtectorSixPlusSix,
        ProtectorNinePlusThree: data.ProtectorNinePlusThree,
        T1Budget: data.T1Budget,
        T1ThreePlusNine: data.T1ThreePlusNine,
        T1SixPlusSix: data.T1SixPlusSix,
        T1NinePlusThree: data.T1NinePlusThree,
        T2Budget: data.T2Budget,
        T2ThreePlusNine: data.T2ThreePlusNine,
        T2SixPlusSix: data.T2SixPlusSix,
        T2NinePlusThree: data.T2NinePlusThree,

        TrackerBudgetVolume: data.TrackerBudgetVolume,
        TrackerThreePlusNineVolume: data.TrackerThreePlusNineVolume,
        TrackerSixPlusSixVolume: data.TrackerSixPlusSixVolume,
        TrackerNinePlusThreeVolume: data.TrackerNinePlusThreeVolume,
        ProtectorBudgetVolume: data.ProtectorBudgetVolume,
        ProtectorThreePlusNineVolume: data.ProtectorThreePlusNineVolume,
        ProtectorSixPlusSixVolume: data.ProtectorSixPlusSixVolume,
        ProtectorNinePlusThreeVolume: data.ProtectorNinePlusThreeVolume,
        T1BudgetVolume: data.T1BudgetVolume,
        T1ThreePlusNineVolume: data.T1ThreePlusNineVolume,
        T1SixPlusSixVolume: data.T1SixPlusSixVolume,
        T1NinePlusThreeVolume: data.T1NinePlusThreeVolume,
        T2BudgetVolume: data.T2BudgetVolume,
        T2ThreePlusNineVolume: data.T2ThreePlusNineVolume,
        T2SixPlusSixVolume: data.T2SixPlusSixVolume,
        T2NinePlusThreeVolume: data.T2NinePlusThreeVolume
      })
      .then(function(value) {
        if (data.Id === 0) {
          data.Id = value.Id;
          context.state.budgets.push(data);
        }
      })
      .catch(function(err) {
        errorHelper.showError(err);
      });
  }
};

const mutations = {
  SET_COURIER_COG(storeState, data) {
    storeState.courierCOG = data;
  },
  SET_FIXED_COST(storeState, data) {
    storeState.fixedCosts = data;
  },
  SET_BUDGET(storeState, data) {
    storeState.budgets = data;
  }
};

const getters = {
  courierCOG: storeState => storeState.courierCOG,
  fixedCosts: storeState => storeState.fixedCosts,
  budgets: storeState => storeState.budgets,
  loading: storeState => storeState.loading
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  services
};
